import { render } from "./B2BSidebar.vue?vue&type=template&id=3adf9c11&scoped=true"
import script from "./B2BSidebar.vue?vue&type=script&lang=js"
export * from "./B2BSidebar.vue?vue&type=script&lang=js"

import "./B2BSidebar.vue?vue&type=style&index=0&id=3adf9c11&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adf9c11"]])

export default __exports__